import { Phone } from "lucide-react";
import { PHONE_LINK } from "@/data/site";

const FloatingCall = () => (
  <a
    href={PHONE_LINK}
    data-testid="floating-call-button"
    aria-label="Call Sage Auto Group now"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-gold py-4 pl-5 pr-6 shadow-[0_8px_40px_rgba(212,175,55,0.35)] transition-[background-color,transform] duration-300 hover:bg-gold-hover hover:-translate-y-1 md:hidden"
  >
    <span className="relative flex h-5 w-5 items-center justify-center">
      <span className="absolute inline-flex h-full w-full animate-pulse-ring rounded-full bg-obsidian/40" />
      <Phone className="relative h-4 w-4 text-obsidian" strokeWidth={2.5} />
    </span>
    <span className="text-xs font-bold uppercase tracking-[0.2em] text-obsidian">Call Now</span>
  </a>
);

export default FloatingCall;
